
const validateUrl = (value) => {
  if (value && !value.match(/^https?:/)) {
    return `http://${value}`;
  }
  return value || "";
}

export default validateUrl;